import React, { useState } from "react";
import styles from "./CollapsibleHeader.module.less";
import Star from "./images/Star.png";
import { classNames } from "@utils/styling";
import { Text } from "src/components/core/Text";
import { useOnce } from "src/hooks/lifecycle";

export const CHECK_EMAIL_REMINDER_PARAM = "showCheckEmailReminder";

function shouldShowCollapsibleHeader() {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.has(CHECK_EMAIL_REMINDER_PARAM);
}

const translationKeyMappings = {
  noomPremium: {
    title: "collapsibleHeader:noomPremium:title",
    body: "collapsibleHeader:noomPremium:body",
  },
  supporterPlan: {
    title: "collapsibleHeader:supporterPlan:title",
    body: "collapsibleHeader:supporterPlan:body",
  },
};

function getI18nKeys(type?: keyof typeof translationKeyMappings) {
  const urlParams = new URLSearchParams(window.location.search);
  return type === urlParams.get(CHECK_EMAIL_REMINDER_PARAM)
    ? translationKeyMappings[type]
    : null;
}

type Props = {
  i18nKeys?: {
    title: string;
    body: string;
  };
  type?: keyof typeof translationKeyMappings;
};

const CollapsibleHeader = ({ i18nKeys, type }: Props) => {
  const [isCollapsed, setCollapsed] = useState(false);

  useOnce(() => {
    setTimeout(() => setCollapsed(true), 500);
  });

  if (!shouldShowCollapsibleHeader()) {
    return null;
  }

  const translationKeys = i18nKeys || getI18nKeys(type);

  if (!translationKeys) {
    return null;
  }

  return (
    <div
      className={classNames(
        styles.collapsableHeader,
        isCollapsed && styles.collapsed
      )}
    >
      <div className={styles.headerHeader}>
        <img className={styles.image} src={Star} alt="" />
        <div className={styles.headerText}>
          <Text i18nKey={translationKeys.title} />
        </div>
      </div>
      <p>
        <Text i18nKey={translationKeys.body} />
      </p>
    </div>
  );
};

export default CollapsibleHeader;
